"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * A texture loader is an extensible way to add more "renderable texture" into gl-react.
 */

var TextureLoader = function () {

  /**
   *
   */
  function TextureLoader(gl) {
    _classCallCheck(this, TextureLoader);

    this.gl = gl;
  }

  /**
   * You must free everything you have done and stop all pending load() calls.
   */


  /**
   * @property {WebGLRenderingContext} gl - the contextual rendering context
   */


  /**
   * Check if the loader should handle a given input
   */


  /**
   * try to get in sync the texture for a given output. otherwise null.
   */


  _createClass(TextureLoader, [{
    key: "load",


    /**
     * load() called if get() was null. it returns a promise and a dispose function.
     * It is your responsability to cache the disposable per input.
     * If load() is called twice, same value should be returned. but you can drop it when it's loaded.
     */
    value: function load(input) {
      // eslint-disable-line no-unused-vars
      // noop default implementation
      return {
        promise: new Promise(noop),
        dispose: noop
      };
    }
  }]);

  return TextureLoader;
}();

exports.default = TextureLoader;
//# sourceMappingURL=TextureLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/TextureLoader.js
// module id = 78
// module chunks = 0